import React, { useEffect, useState } from 'react';
import NewTabulator from "../../NewTabulator/NewTabulator";
import "./FactorJoz.scss";

const FactorJoz = ({ initialData }) => {

  const columns = [
    { title: "کد زبان آموز", field: "ClassCode" },
    { title: "مشخصه ", field: "ClassTitel" },
    { title: "عملیات", field: "Delete", formatter: "checkBox" },
  ];

  return (
    <div className='FactorJozTable'>
      <div className='Table'>
        <NewTabulator
          columns={columns}
          data={initialData.TableData} // Update data prop here
          style={{ height: "45vh", overflowY: "scroll" }}
          className={"header__color__F1F1F1"}
        />
      </div>
    </div>
  );
};

export default FactorJoz;
